import { useEffect, useRef, useState } from 'react';
import {PlannedHoursParams} from '../../../../../../features/shifts/types';
import HttpClient from '../../../../../../api/api';

async function fetchPlannedHours(params: PlannedHoursParams): Promise<number> {
    return await HttpClient.shiftsApi.fetchPlannedHours(params);
}

// avoid duplicate requests when headers re-render
const cache = new Map<string, number>();


function cacheKey(p: PlannedHoursParams) {
    return `${p.employeeId}|${p.startDate}|${p.endDate}`;
}

export function usePlannedHours(params: null | {
    endDate: string;
    employeeId: number;
    startDate: string
}) {
    const [plannedHours, setPlannedHours] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(!!params);
    const [error, setError] = useState<string | null>(null);
    const keyRef = useRef<string | null>(params ? cacheKey(params) : null);


    useEffect(() => {
        if (!params) return;
        const key = cacheKey(params);
        keyRef.current = key;


        const cached = cache.get(key);
        if (typeof cached === 'number') {
            setPlannedHours(cached);
            setIsLoading(false);
            return;
        }


        let cancelled = false;
        setIsLoading(true);
        setError(null);


        fetchPlannedHours(params)
            .then((val) => {
                if (cancelled) return;
                cache.set(key, val);
                setPlannedHours(val);
            })
            .catch((e: unknown) => {
                if (cancelled) return;
                console.error(e);
                setError(e instanceof Error ? e.message : String(e));
                setPlannedHours(0);
            })
            .finally(() => !cancelled && setIsLoading(false));


        return () => {
            cancelled = true;
        };
    }, [params?.employeeId, params?.startDate, params?.endDate]);


    return { plannedHours, isLoading, error };
}